<template>
    <div class="animated fadeIn master-page">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <!-- Top Card: Header, Action & Filter -->
            <div class="header-filter-card mb-4">
                <div class="header-row d-flex align-items-center justify-content-between mb-3">
                    <h4 class="page-title mb-0">Atribut Jenis Barang</h4>
                    <button 
                        type="button" 
                        class="btn btn-tambah"
                        @click="tambahAtribut"
                        name="tambahAtributJenisBarangBtn"
                    >
                        <i class="fa fa-plus mr-1"></i> Tambah Atribut Jenis Barang
                    </button>
                </div>

                <!-- Filter Controls -->
                <div class="filter-controls-row d-flex flex-wrap align-items-center gap-2">
                    <div class="filter-item flex-grow-1" style="max-width: 320px;">
                        <b-form-input 
                            v-model="searchQuery" 
                            name="searchQuery"
                            placeholder="Cari tipe/jenis/merk barang"
                            class="form-control-custom filter-input"
                            @keyup.enter="onSearch"
                        ></b-form-input>
                    </div>
                    <button 
                        type="button" 
                        class="btn btn-search-icon" 
                        :disabled="isBusy" 
                        @click="onSearch" 
                        name="searchBtn"
                        title="Cari"
                    > 
                        <i class="fa fa-search"></i>
                    </button>
                    <button 
                        type="button" 
                        class="btn btn-outline-reset" 
                        :disabled="isBusy" 
                        @click="onReset" 
                        name="resetBtn"
                    >
                        Reset
                    </button>
                </div>
            </div>

            <!-- Table Card -->
            <div class="table-card">
                <div class="table-responsive-wrapper">
                    <b-table 
                        hover 
                        show-empty 
                        :busy="isBusy"
                        :items="paginatedData" 
                        :fields="fields"
                        responsive 
                        class="master-atribut-table mb-0"
                    >
                        <template v-slot:table-busy>
                            <div class="text-center my-4 py-3">
                                <b-spinner class="align-middle text-success mb-2" small></b-spinner>
                                <p class="mb-0 text-muted small">Memuat data atribut jenis barang...</p>
                            </div>
                        </template>

                        <template v-slot:empty>
                            <div class="text-center py-4 text-muted">
                                Tidak ada data atribut jenis barang yang ditemukan.
                            </div>
                        </template>

                        <!-- Slot: TIPE PINJAMAN -->
                        <template v-slot:cell(tipePinjaman)="row">
                            <span class="cell-tipe-pinjaman">{{ row.item.tipePinjaman || '-' }}</span>
                        </template>

                        <!-- Slot: JENIS BARANG -->
                        <template v-slot:cell(jenisBarang)="row">
                            <span class="cell-jenis-barang">{{ row.item.jenisBarang || '-' }}</span>
                        </template>

                        <!-- Slot: MERK BARANG -->
                        <template v-slot:cell(merkBarang)="row">
                            <div class="d-flex flex-wrap align-items-center gap-1 merk-badge-list">
                                <span 
                                    v-for="(merk, mIdx) in row.item.merkList" 
                                    :key="mIdx"
                                    class="badge-merk-pill"
                                >
                                    {{ merk }}
                                </span>
                                <span v-if="!row.item.merkList || row.item.merkList.length === 0" class="text-muted small">
                                    -
                                </span>
                            </div>
                        </template>

                        <!-- Slot: AKSI -->
                        <template v-slot:cell(action)="row">
                            <div class="d-flex align-items-center justify-content-center">
                                <button 
                                    type="button" 
                                    class="btn btn-action-detail"
                                    @click="editAtribut(row.item)"
                                    title="Kelola / Detail Atribut"
                                >
                                    <i class="fa fa-info"></i>
                                </button>
                            </div>
                        </template>
                    </b-table>
                </div>

                <!-- Footer Pagination -->
                <div class="table-pagination-row d-flex flex-wrap align-items-center justify-content-between pt-3">
                    <div class="d-flex align-items-center mb-2 mb-md-0">
                        <span class="mr-2 pagination-label">Tampilkan</span>
                        <b-form-select 
                            v-model="perPage" 
                            :options="perPageOptions" 
                            class="form-control-custom select-per-page mr-3"
                            @change="onPerPageChange"
                        ></b-form-select>
                        <span class="pagination-info text-muted">{{ paginationInfo }}</span>
                    </div>
                    <div>
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="filteredData.length"
                            :per-page="perPage"
                            class="custom-pagination mb-0"
                            prev-text="‹"
                            next-text="›"
                            first-number
                            last-number
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'atribut-jenis-barang',
    data() {
        return {
            initStatus: 0,
            isBusy: false,
            searchQuery: '',
            currentPage: 1,
            perPage: 10,
            perPageOptions: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 50, text: '50' },
                { value: 100, text: '100' }
            ],
            fields: [
                { 
                    key: 'tipePinjaman', 
                    label: 'TIPE PINJAMAN', 
                    thClass: 'text-left align-middle', 
                    tdClass: 'text-left align-middle',
                    thStyle: { width: '18%', minWidth: '130px' }
                },
                { 
                    key: 'jenisBarang', 
                    label: 'JENIS BARANG', 
                    thClass: 'text-left align-middle', 
                    tdClass: 'text-left align-middle',
                    thStyle: { width: '22%', minWidth: '150px' }
                },
                { 
                    key: 'merkBarang', 
                    label: 'MERK BARANG', 
                    thClass: 'text-left align-middle', 
                    tdClass: 'text-left align-middle',
                    thStyle: { width: '48%', minWidth: '220px' }
                },
                { 
                    key: 'action', 
                    label: 'AKSI', 
                    thClass: 'text-center align-middle', 
                    tdClass: 'text-center align-middle',
                    thStyle: { width: '12%', minWidth: '80px' }
                }
            ],
            // Data list master atribut jenis barang
            allData: []
        }
    },
    computed: {
        filteredData() {
            if (!this.searchQuery || this.searchQuery.trim() === '') {
                return this.allData
            }
            const q = this.searchQuery.trim().toLowerCase()
            return this.allData.filter(item => {
                const tipeMatch = item.tipePinjaman && item.tipePinjaman.toLowerCase().includes(q)
                const jenisMatch = item.jenisBarang && item.jenisBarang.toLowerCase().includes(q)
                const merkMatch = item.merkList && item.merkList.some(m => m.toLowerCase().includes(q))
                return tipeMatch || jenisMatch || merkMatch
            })
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage
            const end = start + this.perPage
            return this.filteredData.slice(start, end)
        },
        paginationInfo() {
            const total = this.filteredData.length
            if (total === 0) return 'Menampilkan 0 data'
            const from = (this.currentPage - 1) * this.perPage + 1
            const to = Math.min(this.currentPage * this.perPage, total)
            return `Menampilkan ${from} - ${to} dari ${total} data`
        }
    },
    methods: {
        init() {
            this.initStatus = 0
            this.fetchData().then(() => {
                this.initStatus = 1
            }).catch(() => {
                this.initStatus = 1
            })
        },

        fetchData() {
            this.isBusy = true
            return this.$axios.get("barang-jenis-atribut/").then(response => {
                let rawList = []
                if (Array.isArray(response.data)) {
                    rawList = response.data
                } else if (response.data && Array.isArray(response.data.data)) {
                    rawList = response.data.data
                }

                    this.allData = rawList.map((item, idx) => {
                        let merkNames = []
                        if (Array.isArray(item.merkBarang)) {
                            merkNames = item.merkBarang.map(m => (typeof m === 'object' && m !== null ? m.name : m))
                        } else if (Array.isArray(item.merkList)) {
                            merkNames = item.merkList
                        }

                        let tipePinjamanName = ''
                        let tipePinjamanId = null
                        if (item.jenisPinjaman) {
                            tipePinjamanName = item.jenisPinjaman.name || ''
                            tipePinjamanId = item.jenisPinjaman.id || null
                        } else if (item.tipePinjaman) {
                            tipePinjamanName = typeof item.tipePinjaman === 'object' && item.tipePinjaman !== null ? item.tipePinjaman.name : item.tipePinjaman
                        }

                        let jenisBarangName = item.jenisBarangName || item.jenisBarang || item.name || ''
                        let jenisBarangId = item.jenisBarangId || item.id || (idx + 1)

                        return {
                            id: jenisBarangId,
                            jenisId: jenisBarangId,
                            jenisBarangId: jenisBarangId,
                            tipePinjamanId: tipePinjamanId,
                            tipePinjaman: tipePinjamanName,
                            jenisBarang: jenisBarangName,
                            merkList: merkNames,
                            rawMerkBarang: item.merkBarang || [],
                            totalAtribut: item.totalAtribut !== undefined ? item.totalAtribut : 0,
                            totalWajib: item.totalWajib !== undefined ? item.totalWajib : 0
                        }
                    })
            }).catch(err => {
                console.error("Gagal memuat data dari barang-jenis-atribut/:", err)
            }).finally(() => {
                this.isBusy = false
            })
        },

        onSearch() {
            this.currentPage = 1
        },

        onReset() {
            this.searchQuery = ''
            this.currentPage = 1
        },

        onPerPageChange() {
            this.currentPage = 1
        },

        tambahAtribut() {
            this.$router.push('/master/atribut-jenis-barang/tambah')
        },

        editAtribut(item) {
            let id = item.jenisBarangId || item.jenisId || item.id
            this.$router.push({
                path: `/master/atribut-jenis-barang/${id}/edit`,
                query: {
                    jenisId: id,
                    jenisBarang: item.jenisBarang,
                    tipePinjamanId: item.tipePinjamanId,
                    tipePinjaman: item.tipePinjaman
                }
            })
        }
    },
    created() {
        this.init()
    }
}
</script>

<style lang="scss" scoped>
.master-page {
    padding-bottom: 30px;
}

/* Header & Filter Card */
.header-filter-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px 24px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
    border: 1px solid #edf2f0;
}

.page-title {
    font-size: 20px;
    font-weight: 700;
    color: #0b3b36;
    letter-spacing: -0.2px;
}

.btn-tambah {
    background-color: #0b3b36;
    color: #ffffff;
    border: 1px solid #0b3b36;
    border-radius: 8px;
    padding: 8px 18px;
    font-size: 13.5px;
    font-weight: 600;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover {
        background-color: #082d29;
        border-color: #082d29;
        color: #ffffff;
        box-shadow: 0 2px 8px rgba(11, 59, 54, 0.2);
    }
}

/* Filter Controls */
.filter-controls-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.filter-input {
    min-width: 260px;
}

.form-control-custom {
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    font-size: 13px;
    height: 38px;
    color: #334155;
    background-color: #ffffff;

    &:focus {
        border-color: #0b3b36;
        box-shadow: 0 0 0 2px rgba(11, 59, 54, 0.12);
    }

    &::placeholder {
        color: #94a3b8;
    }
}

.btn-search-icon {
    background-color: #0b3b36;
    color: #ffffff;
    border: 1px solid #0b3b36;
    border-radius: 8px;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover:not(:disabled) {
        background-color: #082d29;
        border-color: #082d29;
        color: #ffffff;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.btn-outline-reset {
    background-color: #ffffff;
    color: #475569;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    height: 38px;
    padding: 0 16px;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover:not(:disabled) {
        background-color: #f8fafc;
        border-color: #cbd5e1;
        color: #1e293b;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

/* Table Card */
.table-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px 24px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
    border: 1px solid #edf2f0;
}

.table-responsive-wrapper {
    overflow-x: auto;
}

.master-atribut-table {
    width: 100%;

    ::v-deep {
        thead th {
            background-color: #fafcfb;
            color: #5e7a75;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.6px;
            text-transform: uppercase;
            border-top: none;
            border-bottom: 1px solid #eef2f1;
            border-left: none;
            border-right: none;
            padding: 14px 16px;
            white-space: nowrap;
        }

        tbody td {
            padding: 14px 16px;
            font-size: 13.5px;
            color: #334155;
            border-top: 1px solid #f1f5f4;
            border-bottom: none;
            border-left: none;
            border-right: none;
            vertical-align: middle;
        }

        tbody tr:hover {
            background-color: #fcfdfd;
        }
    }
}

.cell-tipe-pinjaman {
    color: #475569;
    font-weight: 400;
}

.cell-jenis-barang {
    color: #1e293b;
    font-weight: 600;
}

.merk-badge-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.badge-merk-pill {
    display: inline-block;
    background-color: #eef3f1;
    color: #334155;
    border: 1px solid #dce8e4;
    border-radius: 12px;
    padding: 3px 10px;
    font-size: 11.5px;
    font-weight: 500;
    line-height: 1.3;
}

.btn-action-detail {
    background-color: #e6f4f1;
    color: #0d9488;
    border: 1px solid #ccede5;
    border-radius: 6px;
    width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover {
        background-color: #0b3b36;
        border-color: #0b3b36;
        color: #ffffff;
    }
}

/* Pagination */
.table-pagination-row {
    border-top: 1px solid #f1f5f4;
}

.pagination-label {
    font-size: 13px;
    color: #64748b;
}

.select-per-page {
    width: 70px !important;
    height: 34px;
    font-size: 13px;
    padding: 2px 8px;
}

.pagination-info {
    font-size: 13px;
    color: #64748b;
}

.custom-pagination {
    ::v-deep {
        .page-item .page-link {
            border-radius: 6px;
            margin: 0 2px;
            border: 1px solid #e2e8f0;
            color: #475569;
            font-size: 13px;
            min-width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 6px;
        }

        .page-item.active .page-link {
            background-color: #0b3b36;
            border-color: #0b3b36;
            color: #ffffff;
            font-weight: 600;
        }

        .page-item.disabled .page-link {
            color: #cbd5e1;
            background-color: #f8fafc;
            border-color: #e2e8f0;
        }
    }
}
</style>
